import React from 'react'

const Contact: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0a] pt-32 pb-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="bg-[#141414] rounded-lg border border-white/10 shadow-sm p-6 sm:p-10">
          <div className="space-y-8">
            {/* Header */}
            <div className="text-center space-y-4">
              <h1 className="text-4xl font-bold text-white">
                Contact Us
              </h1>
            </div>

            {/* Contact Information */}
            <div className="space-y-6">
              <div className="text-center space-y-4">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-primary-100 rounded-full">
                  <svg className="w-8 h-8 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0V6a2 2 0 012 2v6a2 2 0 01-2 2H8a2 2 0 01-2-2V8a2 2 0 012-2V6" />
                  </svg>
                </div>

                <div className="space-y-2">
                  <h2 className="text-2xl font-bold text-white">
                    Lunarware
                  </h2>
                </div>
              </div>

              <div className="border-t border-white/10 pt-6">
                <div className="space-y-6">
                  <div className="flex items-center justify-center space-x-4">
                    <div className="flex items-center space-x-3">
                      <div className="flex items-center justify-center w-10 h-10 bg-[#1a1a1a] rounded-full">
                        <svg className="w-5 h-5 text-neutral-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                      </div>
                      <div>
                        <p className="text-sm text-neutral-400">Email</p>
                        <a
                          href="mailto:lunarsoftwaregroup@proton.me"
                          className="text-lg font-medium text-primary-600 hover:text-primary-700 transition-colors"
                        >
                          lunarsoftwaregroup@proton.me
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="text-center">
                    <p className="text-neutral-400 max-w-md mx-auto">
                      We typically respond to inquiries within 24 hours. For technical support or feature requests,
                      please include as much detail as possible in your message.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Additional Information */}
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-[#1a1a1a] rounded-lg p-6 border border-white/10">
                <h3 className="text-lg font-semibold text-white mb-3">
                  About This Service
                </h3>
                <p className="text-neutral-400 text-sm">
                  BMWFinder helps you find BMW M2, M3, M4, and M8
                  vehicles with the coveted carbon fiber bucket seats or individual paint. We scan dealership
                  inventories nationwide and update our database every hour.
                </p>
              </div>

              <div className="bg-[#1a1a1a] rounded-lg p-6 border border-white/10">
                <h3 className="text-lg font-semibold text-white mb-3">
                  Technical Details
                </h3>
                <p className="text-neutral-400 text-sm">
                  Data is sourced from publicly available dealership APIs and websites.
                  We are not affiliated with BMW or any dealership. All vehicle information
                  should be verified directly with the dealership.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact
